import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ProductSelectEvent, StandardEvents } from '@shopify/events';

/**
 * Keeps the product-size accordion in sync with the selected variant.
 * The updated markup comes from Shopify's existing variant section request.
 */
class ProductSize extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  /** @param {ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newProductSize = Array.from(detail.html.querySelectorAll('product-size')).find(
          (element) => element.dataset.blockId === this.dataset.blockId
        );

        if (!(newProductSize instanceof HTMLElement)) return;

        morph(this, newProductSize, { childrenOnly: true });
        this.hidden = newProductSize.hidden;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-size] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-size')) {
  customElements.define('product-size', ProductSize);
}
